import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LedgerService } from "../shared/ledger.service";
import { Ledger } from "../shared/ledger";
import { PrivilegeService } from "../../../staff/Shared/privilege.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-ledgerlist',
  templateUrl: './ledgerlist.component.html',
  styleUrls: ['./ledgerlist.component.css']
})
export class LedgerlistComponent implements OnInit {

  displayedColumns: string[] = ['Name', 'Group', 'SubLedgerName', 'IsAllCompany', 'Active', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  IsAdd: boolean;
  IsEdit: boolean;
  IsDelete: boolean;
  IsView: boolean;
  IsPrint: boolean;
  toast: Toastpayload;

  constructor(private router: Router, private ledgerService: LedgerService,
    private ngxLoader: NgxUiLoaderService,
    private privilegeService: PrivilegeService,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,) {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    // showing Loader 
    this.ngxLoader.start();
    this.getLedgerList();
    this.dataSource.paginator = this.paginator;
    // Closing Loader
    this.ngxLoader.stop();
  }

  getLedgerList() {
    this.ledgerService.FetchLedgerList().subscribe(data => {
      // this.ChequeList$=data;
      // console.log(data);
      this.dataSource.data = data;
    })
  }

  public AddNew() {
    this.router.navigate(['/ledger']);
  }

  Edit(ledger: any) {
    this.router.navigate(['/ledger', ledger.Id]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  // Delete Ledger with Toastr messsage
  Delete(element: any) {

    this.toast = {
      message: "The Ledger have been deleted",
      title: 'Ledger deletion',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    let title: string = "Confirmation";
    let message: string = "If you continue, the ledger will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {
          // centrelink deletion
          this.IUDLedger(element);
        }
        else {
          // console.log(confirmed);
          this.toast.message = 'You are cancelled the ledger deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  // Ledger delete action
  IUDLedger(element: any): any {

    this.ledgerService.selectedLedger = new Ledger;
    this.ledgerService.selectedLedger.Id = element.Id;  // LedgerId
    this.ledgerService.selectedLedger.IsActive = 0;  // deactivate
    this.ledgerService.selectedLedger.Flag = 3; // deactivate Flag

    // IUD, delete action 
    const promiseValue = new Promise<boolean>((resolve, reject) => {

      this.ledgerService.IUDLedger(this.ledgerService.selectedLedger)
        .toPromise()
        .then(data => {
          // this.router.navigate(['/ledgerlist']);
          if (data.ResponseId != 200) {
            return false;
          }
          else {
            // this.ngOnInit();
            return true;
          }
        })
        .catch(err => { console.log(err); reject(false) });

      resolve(true);
    });

    promiseValue.then((value) => {

      if (value) {
        this.ngOnInit();
      }
      else {
        this.toast.message = 'The ledger deletion failed.!'
        this.toast.type = 'error';
        this.toasterserviceService.showToast(this.toast);
      }

    });
  }

}
